import { render, staticRenderFns } from "./staffResult.vue?vue&type=template&id=6d254542&scoped=true&"
import script from "./staffResult.vue?vue&type=script&lang=js&"
export * from "./staffResult.vue?vue&type=script&lang=js&"
import style0 from "./staffResult.vue?vue&type=style&index=0&id=6d254542&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d254542",
  null
  
)

export default component.exports